<nav class="navbar fixed-top d-flex flex-row align-items-center">
  <!-- <div class="d-flex flex-row align-items-center"> -->
  <div class="d-flex align-items-center navbar-left">
    <a (click)="menuButtonClick($event, sidebar.menuClickCount, sidebar.containerClassnames); false;"
      href="javascript:;" class="menu-button d-none d-md-block">
      <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
        <rect x="0.48" y="0.5" width="7" height="1" />
        <rect x="0.48" y="7.5" width="7" height="1" />
        <rect x="0.48" y="15.5" width="7" height="1" />
      </svg> {{" "}}
      <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
        <rect x="1.56" y="0.5" width="16" height="1" />
        <rect x="1.56" y="7.5" width="16" height="1" />
        <rect x="1.56" y="15.5" width="16" height="1" />
      </svg>
    </a>

    <a (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)" href="javascript:;"
      class="menu-button-mobile d-xs-block d-sm-block d-md-none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
        <rect x="0.5" y="0.5" width="25" height="1" />
        <rect x="0.5" y="7.5" width="25" height="1" />
        <rect x="0.5" y="15.5" width="25" height="1" />
      </svg>
    </a>
  </div>

  <a class="navbar-logo" [routerLink]="adminRoot">
    <span class="logo d-none d-xs-block"></span>
    <span class="logo-mobile d-block d-xs-none"></span>
  </a>

  <div class="navbar-right">
    <div class="header-icons d-inline-block align-middle">

      <div class="user d-inline-block">
        <span>
          <img alt="Profile Picture" [src]="dpCompany" onerror="this.src='/assets/img/profiles/user.png'"
            style="width: 80px; height: 65px;" />
        </span>
      </div>

      <div class="d-none d-md-inline-block align-text-bottom mr-1">
        <div class="custom-control custom-switch" tooltip="Dark Mode" placement="left">
          <input type="checkbox" class="custom-control-input" id="darkModeSwitch" [checked]="isDarkModeActive"
            (change)="onDarkModeChange($event)">
          <label class="custom-control-label" for="darkModeSwitch"></label>
        </div>
      </div>

      <button style="cursor: pointer !important;" class="header-icon btn btn-empty d-none d-sm-inline-block"
        data-toggle="tooltip" title="ToDo" data-placement="bottom" type="button" id="fullScreenButton"
        (click)="fullScreenClick()">
        <i *ngIf="!isFullScreen" class="simple-icon-size-fullscreen"></i>
        <i *ngIf="isFullScreen" class="simple-icon-size-actual"></i>
      </button>

      <!-- ============ NOTIFICATION BELL ============ -->
      <div class="notification-wrapper d-inline-block">
        <button class="header-icon btn btn-empty p-0 position-relative" type="button" (click)="toggleNotif($event)"
          aria-label="Notifications">
          <i class="simple-icon-bell"></i>
          <span class="notification-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
        </button>

        <div class="dropdown-menu dropdown-menu-right notification-dropdown mt-3" [class.show]="notifOpen"
          [style.display]="notifOpen ? 'block' : 'none'" (click)="$event.stopPropagation()">

          <!-- Header -->
          <div class="notif-header">
            <h6 class="mb-0">Notifications</h6>
            <div class="d-flex align-items-center gap-2">
              <button class="mark-all-btn" (click)="markAllAsRead()" *ngIf="unreadCount > 0">
                Mark all as read
              </button>
              <button class="notif-close-btn" (click)="closeNotif()" aria-label="Close">
                &times;
              </button>
            </div>
          </div>

          <!-- Tabs -->
          <div class="notif-tabs">
            <button class="notif-tab" [class.active]="notifFilter === 'all'" (click)="setNotifFilter('all')">
              All
            </button>
            <button class="notif-tab" [class.active]="notifFilter === 'unread'" (click)="setNotifFilter('unread')">
              Unread
            </button>
          </div>

          <!-- List -->
          <div class="notif-list">
            <ng-container *ngIf="filteredNotifications.length > 0; else noNotifications">
              <div *ngFor="let n of filteredNotifications" class="notif-item" [class.unread]="!n.read"
                (click)="openNotificationDetail(n, $event)">
                <div class="notif-icon" [ngClass]="n.type">
                  <i [ngClass]="getNotifIcon(n.type)"></i>
                </div>
                <div class="notif-content">
                  <div class="notif-top">
                    <span class="notif-title">{{ n.title }}</span>
                    <span class="notif-time">{{ n.time }}</span>
                  </div>
                  <p class="notif-message">{{ n.message }}</p>
                </div>
                <span class="notif-dot" *ngIf="!n.read"></span>
              </div>
            </ng-container>

            <ng-template #noNotifications>
              <div class="notif-empty">No notifications yet 🎉</div>
            </ng-template>
          </div>

          <!-- Footer -->
          <div class="notif-footer">
            <a href="javascript:;">View all notifications</a>
          </div>
        </div>
      </div>
      <!-- ============ END NOTIFICATION BELL ============ -->
    </div>

    <div class="user d-inline-block" dropdown>
      <button class="btn btn-empty p-0" type="button" dropdownToggle>
        <span class="name">{{displayName}}</span>
        <span>
          <img alt="Profile Picture" [src]="dpImage" onerror="this.src='/assets/img/profiles/user.png'" />
        </span>
      </button>

      <div class="dropdown-menu dropdown-menu-right mt-3" *dropdownMenu role="menu">
        <a class="dropdown-item c-pointer" (click)="openModalAdd(addNewModal)">Change Password</a>
        <li class="divider dropdown-divider"></li>
        <a class="dropdown-item c-pointer" (click)="onSignOut()">Sign out</a>
      </div>
    </div>

  </div>
  <!-- </div> -->
</nav>

<ng-template #addNewModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Change Password</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3">Previous Password</span>
      </div>
      <input [type]="showold ? 'text' : 'password'" class="form-control" id="oldpassword" id="oldpasswordField"
        style="height: 37px;border-right: none;" aria-describedby="basic-addon3" autocomplete="off">
      <div class="input-group-prepend">
        <span class="eyeSpan"><i [ngClass]="showold ? 'simple-icon-eye eye-btn' : 'simple-icon-eye eye-btn'"
            id="togglePassword" (click)="textoldPassword()"></i> </span>
      </div>
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3"> New Password</span>
      </div>
      <input [type]="show ? 'text' : 'password'" class="form-control" id="password" id="passwordField"
        style="height: 37px;border-right: none;" aria-describedby="basic-addon3" autocomplete="off">
      <div class="input-group-prepend">
        <span class="eyeSpan"><i [ngClass]="show ? 'simple-icon-eye eye-btn' : 'simple-icon-eye eye-btn'"
            id="togglePassword" (click)="textPassword()"></i> </span>
      </div>
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3">Re-Type Password</span>
      </div>
      <input [type]="showre ? 'text' : 'password'" class="form-control" id="repassword" id="repasswordField"
        aria-describedby="basic-addon3" style="height: 37px;border-right: none;" autocomplete="off">
      <div class="input-group-prepend">
        <span class="eyeSpan"><i [ngClass]="showre ? 'simple-icon-eye eye-btn' : 'simple-icon-eye eye-btn'"
            id="togglePassword" (click)="textRePassword()"></i> </span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" (click)="Submit()" class="btn btn-primary">Save</button>
  </div>
</ng-template>

<ng-template #modalmessage>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{caption}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefMessage.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{msg}}</p>
  </div>
  <div class="modal-footer">
    <button type="submit" (click)="OK()" class="btn btn-primary">OK</button>
  </div>
</ng-template>

<!-- ============ NOTIFICATION DETAIL MODAL ============ -->
<ng-template #notificationDetailModal>
  <div class="modal-header notif-modal-header">
    <div class="d-flex align-items-center gap-3">
      <div class="notif-icon" [ngClass]="selectedNotif?.type">
        <i [ngClass]="getNotifIcon(selectedNotif?.type)"></i>
      </div>
      <div>
        <h5 class="modal-title mb-0">{{ selectedNotif?.title }}</h5>
        <small class="text-muted">{{ selectedNotif?.time }}</small>
      </div>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="notifModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p class="notif-detail-msg">{{ selectedNotif?.message }}</p>

    <div class="notif-detail-meta">
      <div class="meta-row">
        <span class="meta-label">Type:</span>
        <span class="meta-value text-capitalize">{{ selectedNotif?.type }}</span>
      </div>
      <div class="meta-row">
        <span class="meta-label">Received:</span>
        <span class="meta-value">{{ selectedNotif?.time }}</span>
      </div>
      <div class="meta-row">
        <span class="meta-label">Status:</span>
        <span class="meta-value">
          <span class="badge" [ngClass]="selectedNotif?.read ? 'badge-success' : 'badge-primary'">
            {{ selectedNotif?.read ? 'Read' : 'Unread' }}
          </span>
        </span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="notifModalRef.hide()">Close</button>
    <button type="button" class="btn btn-primary" (click)="markSelectedAsRead()"
      *ngIf="selectedNotif && !selectedNotif.read">
      Mark as Read
    </button>
  </div>
</ng-template>

<style>
  .notification-wrapper {
    position: relative;

    .header-icon {
      position: relative;
      background: transparent;
      border: none;
      color: inherit;

      .simple-icon-bell {
        font-size: 18px;
      }
    }

    .notification-badge {
      position: absolute;
      top: -4px;
      right: -6px;
      background: #ef4444;
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      line-height: 1;
      padding: 3px 5px;
      border-radius: 999px;
      min-width: 16px;
      text-align: center;
    }
  }

  .notification-dropdown {
    width: 360px;
    padding: 0;
    border: none;
    border-radius: 12px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    max-height: 520px;
    display: flex;
    flex-direction: column;

    .notif-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 16px 10px;
      border-bottom: 1px solid #e2e8f0;

      h6 {
        font-size: 15px;
        font-weight: 700;
      }

      .mark-all-btn {
        border: none;
        background: transparent;
        color: #2563eb;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .notif-tabs {
      display: flex;
      gap: 8px;
      padding: 10px 16px;
      border-bottom: 1px solid #e2e8f0;

      .notif-tab {
        border: none;
        background: #f1f5f9;
        color: #475569;
        padding: 5px 12px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;

        &.active {
          background: #0f172a;
          color: #fff;
        }
      }
    }

    .notif-list {
      flex: 1;
      overflow-y: auto;
      max-height: 360px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 999px;
      }
    }

    .notif-item {
      display: flex;
      gap: 12px;
      padding: 12px 16px;
      border-bottom: 1px solid #f1f5f9;
      cursor: pointer;
      position: relative;
      transition: background 0.2s;

      &:hover {
        background: #f8fafc;
      }

      &.unread {
        background: #f0f9ff;

        &:hover {
          background: #e0f2fe;
        }
      }

      .notif-icon {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: #e2e8f0;

        &.order {
          background: #dcfce7;
          color: #16a34a;
        }

        &.promo {
          background: #fef3c7;
          color: #d97706;
        }

        &.system {
          background: #e0e7ff;
          color: #4f46e5;
        }

        &.chat {
          background: #fce7f3;
          color: #db2777;
        }
      }

      .notif-content {
        flex: 1;
        min-width: 0;

        .notif-top {
          display: flex;
          justify-content: space-between;
          gap: 8px;
          margin-bottom: 2px;

          .notif-title {
            font-size: 13px;
            font-weight: 700;
            color: #0f172a;
          }

          .notif-time {
            font-size: 11px;
            color: #94a3b8;
            white-space: nowrap;
          }
        }

        .notif-message {
          font-size: 12px;
          color: #64748b;
          line-height: 1.4;
          margin: 0;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .notif-dot {
        width: 8px;
        height: 8px;
        background: #3b82f6;
        border-radius: 50%;
        position: absolute;
        right: 12px;
        top: 16px;
      }
    }

    .notif-empty {
      padding: 36px 16px;
      text-align: center;
      color: #94a3b8;
      font-size: 13px;
    }

    .notif-footer {
      padding: 10px 16px;
      text-align: center;
      border-top: 1px solid #e2e8f0;
      background: #f8fafc;

      a {
        font-size: 13px;
        font-weight: 600;
        color: #2563eb;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .notif-header {
    .notif-close-btn {
      border: none;
      background: transparent;
      font-size: 20px;
      line-height: 1;
      color: #64748b;
      cursor: pointer;
      padding: 0 2px;

      &:hover {
        color: #ef4444;
      }
    }
  }
</style>